export const summaryTexts = {
  orderSummaryTitle: 'Order total',
  highlightedText: 'Nice!',
  ordinaryTextStart: 'You get free delivery on your first box (usually',
  ordinaryTextEnd: ') as a welcome treat.',
}
